import i18n from 'i18next';

import { AdditionalIncomeOption } from '../types/AdditionalIncomeOption';
import { NO, YES } from '../types/YesOrNo';

export const additionalIncomeTypeOptions: AdditionalIncomeOption[] = [
  {
    name: i18n.t('additionalIncome.yes'),
    value: YES,
  },
  {
    name: i18n.t('additionalIncome.no'),
    value: NO,
  },
];
